import { SendOcaLinkSendMethods } from '@trnsact/trnsact-shared-types';
import { SendApplicationFormTemplates } from './types';

export const sendMethodOptions = [
  { label: 'Email', value: SendOcaLinkSendMethods.Email },
  { label: 'Text', value: SendOcaLinkSendMethods.Text },
  { label: 'Email and Text', value: SendOcaLinkSendMethods.TextAndEmail },
];

export const creditAppTemplateOptions = [
  { label: 'Dealer Credit Application Template', value: SendApplicationFormTemplates.Personal },
  { label: 'Lender Credit Application Template', value: SendApplicationFormTemplates.Lender },
];

export const enum TestIds {
  TemplateRadioGroup = 'TemplateRadioGroup',
  LenderCreditAppTemplate = 'LenderCreditAppTemplate',
  EmailInput = 'EmailInput',
  MobilePhoneInput = 'MobilePhoneInput',
  SendViaRadioGroup = 'SendViaRadioGroup',
}
